import { render, staticRenderFns } from "./new_event.vue?vue&type=template&id=3bf684c9&scoped=true"
import script from "./new_event.vue?vue&type=script&lang=js"
export * from "./new_event.vue?vue&type=script&lang=js"
import style0 from "./new_event.vue?vue&type=style&index=0&id=3bf684c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf684c9",
  null
  
)

export default component.exports